import { api } from "app/data/api";
import { Equipment } from "../equipmentServices/Equipment";
import { User } from "../userServices/user";
import { UserCredit } from "../transferCreditServices/TransferCredit";

export type Invoices = Invoice[];
export type InvoiceListProps = List[];

export interface List {
  id: number;
  date: string;
  discount: string;
  invoice_status_id: number;
  description: any;
  total_value: string;
  created_by: number;
  created_at: string;
  updated_at: string;
  invoice_status: InvoiceStatus;
  invoice_credits: InvoiceCredit[];
  user: User;
  reservations: Reservation[];
  service_orders: ServiceOrder[];
  fai: string
}

export interface InvoiceStatus {
  id: number;
  name: string;
  description: string;
  created_at: string;
  updated_at: any;
}

export interface InvoiceCredit {
  id: number;
  invoice_id: number;
  user_credit_id: number;
  value: string;
  created_at: string;
  updated_at: string;
  user_credit?: UserCredit;
  invoice: {
    id: number;
    date: string;
    discount: string;
    invoice_status_id: number;
    description: string;
    total_value: string;
    invoice_status: InvoiceStatus;
  };
}

export interface Invoice {
  reservations: Reservation[];
  serviceOrders: ServiceOrder[];
}

export interface Reservation {
  id: number;
  equipment_id: number;
  user_id: number;
  date: string;
  start_time: string;
  end_time: string;
  value: number;
  manager_id: number;
  operator_id: number;
  service_order_id: number;
  type: string;
  active: number;
  invoice_id: any;
  created_at: string;
  updated_at: string;
  equipment: Equipment;
  user: User;
}

export interface ServiceOrder {
  id: number;
  user_id: number;
  request_date: string;
  approvation_date: string;
  delivery_date: string;
  finish_date: string;
  service_order_status_id: number;
  operator_id: number;
  prepare_sample: number;
  service_sample_option_id: number;
  receipt_date: string;
  requester_name: string;
  requester_id: number;
  service_description: string;
  features_to_note: string;
  amount_samples: number;
  sample_description: string;
  created_by: number;
  active: number;
  invoice_id: any;
  created_at: string;
  updated_at: string;
  total_service: number;
  service_order_service: ServiceOrderService[];
  service_order_log: ServiceOrderLog[]
  user: User;
}

export interface ServiceOrderLog {
  id: number
  service_order_id: number
  user_id: number
  request_date: string
  approvation_date: string
  delivery_date: string
  finish_date: string
  service_order_status_id: number
  operator_id: number
  prepare_sample: number
  service_sample_option_id: number
  receipt_date: any
  user_requester_id: number
  requester_name: string
  service_description: string
  features_to_note: string
  amount_samples: number
  sample_description: string
  created_by: number
  invoice_id: any
  created_at: string
  updated_at: string
  service_order_status: ServiceOrderStatus
}

export interface ServiceOrderStatus {
  id: number
  description: string
  created_at: string
  updated_at: string
}

export interface ServiceOrderService {
  id: number;
  service_order_id: number;
  service_id: number;
  amount: number;
  value: string;
  active: number;
  created_at: string;
  updated_at: string;
}

export interface InvoiceStatus {
  id: number;
  name: string;
  description: string;
  created_at: string;
  updated_at: any;
}

export const fetchInvoices = async () => {
  return await api.get("/invoice/list");
};

export const fetchInvoice = async (id) => {
  return await api.get(`/invoice/find/${id}`);
};

export const fetchPendingInvoiceIssues = async (id) => {
  return await api.get(`/invoice/pendingIssues/${id}`);
};

export const registerInvoice = async (data) => {
  return await api.post("/invoice/create", {
    ...data,
  });
};

export const deleteInvoice = async (id: number | string) => {
  return await api.delete(`/invoice/remove/${id}`);
};

export const editInvoice = async (values, id: number) => {
  return await api.patch(`/invoice/edit/${id}`, {
    ...values,
  });
};

export const fetchInvoiceChangeStatus = async (id: number) => {
  return await api.patch(`/invoice/status/${id}`, {
    invoice_status_id: 2,
  });
};

export const fetchInvoiceStatus = async () => {
  return await api.get("/invoice/listStatus");
};

export const postFaiFile = async (data: any) => {
  return await api.post("/invoice/faiFile", {
    ...data,
  });
}
